import type {RouteRecordRaw} from "vue-router";
import {EPermissao} from "@/core/type/permissao.type";

export const ordemFabricacaoRoutes: RouteRecordRaw[] = [
    {
        path: "/ordem-fabricacao",
        name: "ordem-fabricacao",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_GESTAO_ORDEM_FABRICACAO},
        component: () => import("@/modules/ordemFabricacao/pages/PageOrdemFabricacao.vue")
    },
];
